module.exports = __webpack_public_path__ + "img/tl4a-dub.a7199290.jpg";